// extracted by mini-css-extract-plugin
export default {"alert-wrapper":"jJy4KrfpAnlKgO8t2NMj"};